import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "@shopify/polaris";
import styles from "../ActionTable.module.css";

const CellWithName = ({ action }) => {
    const cellContentRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const cellWidth = cellContentRef.current.offsetWidth;
        const contentWidth = cellContentRef.current.firstChild.offsetWidth;

        setIsOverflowing(contentWidth > cellWidth);
    }, [action.name]);

    return (
        <div className={styles['content-cell-container']} ref={cellContentRef}>
            {isOverflowing ? (
                <Tooltip content={action.name} dismissOnMouseOut width="wide">
                    <span>{action.name}</span>
                </Tooltip>
            ) : (
                <span>{action.name}</span>
            )}
        </div>
    );
};

export default CellWithName;
